import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Drawer, Button, Space, Table, Typography, Modal, Form, Input, message } from 'antd';
import { getUserMessagesApi, deleteUserMessageApi, sendMessageApi } from '@services/MedProject';
import { TABLE_PAGE_SIZE_OPTIONS } from '@/utils/property';

const { Text } = Typography;

let curMessageId; // 当前编辑的留言 ID

export default function UserMessage({ userMessageVisible, setUserMessageVisible }) {
    const params = useParams();
    const projectId = (params?.projectId ?? params?.id) || 0; // 项目 ID

    const [form] = Form.useForm();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleOk = () => {
        form.validateFields().then(async values => {
            console.log(values);
            const res = await sendMessageApi({
                id: curMessageId,
                source: 'system',
                projectId,
                content: values.content,
            });
            if (res.status_code === 200) {
                setIsModalOpen(false);
                message.success('操作成功');
                getUserMessages();
                form.resetFields();
            }
        });
    };

    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };

    const columns = [
        {
            title: '内置留言内容',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '内置留言人',
            dataIndex: 'reviewedBy',
            key: 'reviewedBy',
        },
        {
            title: '内置留言时间',
            dataIndex: 'createdAt',
            key: 'createdAt',
        },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Space size="medium">
                    <Button type="link" onClick={() => onEdit(record)}>
                        编辑
                    </Button>
                    <Button type="link" onClick={() => onDelete(record.id)}>
                        删除
                    </Button>
                </Space>
            ),
        },
    ];

    const closeDrawer = () => {
        setUserMessageVisible(false);
    };

    const addMessage = () => {
        setTitle('新增内置留言');
        setIsModalOpen(true);
        curMessageId = undefined;
    };

    const onEdit = row => {
        curMessageId = row.id;
        setTitle('编辑内置留言');
        setIsModalOpen(true);
        form.setFieldsValue({
            content: row.content,
        });
    };

    const onDelete = id => {
        Modal.confirm({
            title: '你确定删除此内置留言吗？',
            onOk: async () => {
                const res = await deleteUserMessageApi({ id });
                if (res.status_code === 200) {
                    message.success('操作成功');
                    getUserMessages();
                }
            },
        });
    };

    const getUserMessages = () => {
        setLoading(true);
        getUserMessagesApi({ source: 'system', projectId, page, pageSize }).then(res => {
            setLoading(false);
            if (res.status_code === 200 && res.data) {
                setData(res.data.list || []);
                setTotal(res.data.totalCount);
            }
        });
    };

    useEffect(() => {
        if (userMessageVisible) {
            getUserMessages();
        }
    }, [page, pageSize, userMessageVisible]);

    return (
        <>
            <Drawer title="内置留言" className="site-module site-module-home" size="100%" placement="bottom" open={userMessageVisible} onClose={closeDrawer} footer={null} closable={{ placement: 'end' }}>
                <div style={{ marginBottom: '20px' }}>
                    <Button type="primary" onClick={addMessage} style={{ marginRight: '10px' }}>
                        新增内置留言
                    </Button>
                    <Text type="secondary">内置留言即平台运营根据需要内置的留言，添加后即对外直接展示（名字、头像系统会自动虚构生成），请酌情使用该功能</Text>
                </div>
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={{
                        total: total,
                        pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                        showQuickJumper: true,
                        onChange: (page, pageSize) => {
                            setPage(page);
                            setPageSize(pageSize);
                        },
                        showTotal: () => `共 ${total} 条`,
                    }}
                />
            </Drawer>

            <Modal title={title} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    name="basic"
                    form={form}
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 24,
                    }}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        label="内置留言："
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: '请输入内置留言内容',
                            },
                        ]}
                    >
                        <Input.TextArea placeholder="请输入内置留言内容" rows={4} maxLength={200} showCount />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
